// import { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Chip, Stack } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { VscNewFile } from 'react-icons/vsc';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useNavigate } from 'react-router-dom';
// import { FaFileExcel } from 'react-icons/fa';
// import { MdLocationPin } from 'react-icons/md';
// import { FaUser } from 'react-icons/fa';
// import { useAuth } from '../context/AuthContext';

// export default function InquiryDetailsV4({ loggedInUser, companyData, connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const API = connectionString;
//     const path = `${API}/api/inquiries`;
//     const navigate = useNavigate();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     const [filters, setFilters] = useState({ clientname: '', mobileNo: '' });

//     useEffect(() => {
//         fetchData();
//     }, [paginationModel]);

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const offset = paginationModel.page * paginationModel.pageSize;
//             console.log(path);
//             const res = await axios.get(path, {
//                 params: {
//                     ...filters,
//                     offset,
//                     limit: paginationModel.pageSize,
//                     userId,
//                     companyId,
//                     role
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });

//             const countRes = await axios.get(`${API}/api/inq/count`, {
//                 params: { companyId, userId, role }
//             });
//             console.log(res.data.records);
//             setRows(res.data.records || []);
//             setTotalCount(res.data.records.length || 0);
//         } catch (err) {
//             console.error('Error fetching inquiries:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDelete = async () => {
//         if (selectionModel.length === 0) return;

//         try {
//             console.log('Sending delete request for IDs:', selectionModel);
//             const res = await axios.post(`${path}/delete`, { userId, objAryId: selectionModel });
//             console.log('Delete response:', JSON.stringify(res.data, null, 2));

//             if (res.status === 204) {
//                 const inquiryNumbers = res.data?.inquiries || selectionModel;
//                 setSnackbar({
//                     open: true,
//                     message: `These inquiries have multiple follow-ups and were not deleted: ${inquiryNumbers.join(', ')}`,
//                     severity: 'warning'
//                 });
//             } else if (res.status === 200) {
//                 setSnackbar({
//                     open: true,
//                     message: 'Deleted successfully.',
//                     severity: 'success'
//                 });
//                 fetchData();
//                 setSelectionModel([]);
//             }
//         } catch (err) {
//             console.error('Delete error:', err);
//             console.log('Error response:', JSON.stringify(err.response, null, 2));
//             let message = 'Delete failed due to an unexpected error.';
//             if (err.response) {
//                 if (err.response.status === 400) {
//                     message = err.response.data.error || err.response.data.message || `Delete failed with status 400: ${JSON.stringify(err.response.data)}`;
//                 } else {
//                     message = `Delete failed with status ${err.response.status}: ${err.response.data?.message || JSON.stringify(err.response.data)}`;
//                 }
//             } else if (err.request) {
//                 console.log('No response received:', err.request);
//                 message = 'Delete failed: No response from server. Check if the server is running or the endpoint is correct.';
//             } else {
//                 console.log('Error message:', err.message);
//                 message = `Delete failed: ${err.message}`;
//             }
//             setSnackbar({ open: true, message, severity: 'error' });
//         }
//     };

//     const funExportData = async () => {
//         try {
//             const res = await axios({
//                 url: `${path}/export`,
//                 method: 'GET',
//                 responseType: 'blob',
//                 params: {
//                     userId,
//                     companyId,
//                     role,
//                 },
//             });

//             const url = window.URL.createObjectURL(new Blob([res.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'InquiryExport.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (err) {
//             console.error('Export error:', err);
//             setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//         }
//     };

//     const columns = [
//         {
//             field: 'inquiryNumber', headerName: 'Inquiry No', flex: 0.5,
//             renderCell: (params) => {
//                 const row = params.row;
//                 const inquiryDate = row.InqDate
//                     ? new Date(row.InqDate).toLocaleDateString('en-GB')
//                     : '-';

//                 return (
//                     <Box>
//                         <Typography variant="subtitle2">
//                             {row.InqNo || '-'}
//                         </Typography>
//                         <Typography variant="body2" color="text.secondary">
//                             {inquiryDate}
//                         </Typography>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: 'FirmName', headerName: 'Client Info', flex: 2.4, sortable: false,
//             renderCell: (params) => {
//                 const row = params.row;
//                 return (
//                     <Box onClick={() => navigate('/main/v2/inquiry', { state: { mode: 'edit', inquiryData: { inquiry: row }, }, })} sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1, }} >
//                         <Typography variant="subtitle2" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}>
//                             {row.FirmName}
//                         </Typography>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <FaUser color="#FF9800" />
//                             <Typography variant="body2">{row.clientContact || '-'}</Typography>
//                         </Stack>
//                         <Typography variant="body2" color="text.secondary">
//                             📲 {row.MobileNo || '-'}
//                         </Typography>
//                         {row.emailId && (
//                             <Typography variant="body2" color="text.secondary">
//                                 📧 {row.EmailId}
//                             </Typography>
//                         )}
//                         {(row.Address || row.city) && (
//                             <Typography variant="body2" color="text.secondary" display="flex" alignItems="center" gap={0.6}>
//                                 <MdLocationPin style={{ color: '#1877F2' }} /> {row.City ? ` ${row.City}` : ''}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: 'offerPrice', headerName: 'Prices', flex: 0.7, align: 'right', headerAlign: 'center',
//             renderCell: (params) => {
//                 const offer = params.row.OfferPrice || "0.00";
//                 const closing = params.row.ClosingPrice || "0.00";
//                 return (
//                     <Box sx={{ mr: 0 }}>
//                         <Typography variant="body2" sx={{ fontWeight: 600 }}> Offer: ₹{offer} </Typography>
//                         <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}> Closing: ₹{closing} </Typography>
//                     </Box>
//                 );
//             }
//         },
//         {
//             field: 'LaststatusName', headerName: 'Status', flex: 0.5, align: 'right', headerAlign: 'right',
//             renderCell: (params) => {
//                 const status = params.value?.toLowerCase();
//                 let chipColor = 'default';
//                 let chipLabel = params.value || '—';
//                 let chipStyles = {};
//                 if (status === 'success') {
//                     chipColor = 'success';
//                 } else if (status === 'failed') {
//                     chipStyles = { backgroundColor: '#D32F2F', color: '#fff' };
//                 } else {
//                     chipStyles = { backgroundColor: '#FF4C00', color: '#fff' };
//                 }
//                 return (
//                     <Chip label={chipLabel} color={chipColor !== 'default' ? chipColor : undefined} size="small" sx={{ fontWeight: 600, ...chipStyles }} />
//                 );
//             }
//         },
//         { field: 'EmployeeName', headerName: 'Source', align: 'right', headerAlign: 'right', flex: 0.4 },
//         { field: 'Lastpriority', headerName: 'Priority', align: 'right', headerAlign: 'right', flex: 0.2 },
//     ];

//     if (role !== "User") {
//     columns.push({
//         flex: 0.3,
//         sortable: false,
//         filterable: false,
//         disableColumnMenu: true,
//         align: 'right',
//         headerAlign: 'right',
//         renderCell: (params) => {
//             const isSelected = selectionModel.includes(params.row.InqId);
//             return (
//                 <Tooltip title="Delete">
//                     <span>
//                         <IconButton
//                             color="error"
//                             onClick={handleDelete}
//                             disabled={!isSelected}
//                         >
//                             <DeleteIcon fontSize="small" />
//                         </IconButton>
//                     </span>
//                 </Tooltip>
//             );
//         }
//     });
// }

//     return (
//         <Box sx={{ pt: 1 }}>
//             {/* Toolbar */}
//             <Grid container alignItems="center" spacing={2}>
//                 <Grid item xs={2}>
//                     <Tooltip title="Add Inquiry">
//                         <IconButton sx={{ color: 'orange' }} onClick={() => navigate('/main/v2/inquiry', { state: { mode: 'insert' } })} >
//                             <VscNewFile />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Export to Excel" disableHoverListener={selectionModel.length === 0}>
//                         <span>
//                             <IconButton color="success" onClick={funExportData} >
//                                 <FaFileExcel />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 </Grid>
//                 <Grid item xs={8} sx={{ textAlign: 'center' }}>
//                     <Typography variant="h5" gutterBottom> Inquiry Details </Typography>
//                 </Grid>
//                 <Grid item xs={2} sx={{ textAlign: 'right' }}>
//                 </Grid>
//             </Grid>

//             {/* DataGrid */}
//             <Paper sx={{ mt: 1, bgcolor: '#fff', borderRadius: 2, marginX: 1 }}>
//                 <Box sx={{ maxHeight: '84vh', maxWidth: '100%', overflow: 'auto' }}>
//                     <DataGrid
//                         autoHeight
//                         getRowHeight={() => 'auto'}
//                         rows={rows}
//                         columns={columns}
//                         getRowId={(r) => r.InqId}
//                         checkboxSelection={role !== "User"}
//                         selectionModel={selectionModel}
//                         onSelectionModelChange={(newSel) => setSelectionModel(newSel.map(Number))}
//                         disableSelectionOnClick
//                         loading={loading}
//                         pagination
//                         pageSize={paginationModel.pageSize}
//                         page={paginationModel.page}
//                         rowCount={totalCount}
//                         paginationMode="server"
//                         onPageChange={(page) => setPaginationModel(p => ({ ...p, page }))}
//                         onPageSizeChange={(ps) => setPaginationModel(p => ({ ...p, pageSize: ps }))}
//                         rowsPerPageOptions={[50, 100, 150]}
//                         sx={{
//                             '& .MuiDataGrid-columnHeaders': {
//                                 backgroundColor: '#165bb5',
//                                 color: '#FFFFFF',
//                                 fontWeight: 'bold',
//                             },
//                             '& .MuiDataGrid-row:nth-of-type(odd)': {
//                                 backgroundColor: '#FFFFFF',
//                             },
//                             '& .MuiDataGrid-row:nth-of-type(even)': {
//                                 backgroundColor: '#ecf4fc',
//                             },
//                             '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
//                                 color: '#ffffff !important',
//                             },
//                             '& .MuiDataGrid-columnHeaderCheckbox .Mui-checked': {
//                                 color: '#ffffff !important',
//                             }
//                         }}
//                     />
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
//             </Snackbar>
//         </Box>
//     );
// }















// import { useState, useEffect, useMemo } from 'react';
// import axios from 'axios';
// import { Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Chip, Stack, TextField, InputAdornment, useTheme, useMediaQuery, Card, CardContent, Avatar, Checkbox, Divider, Button } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { VscNewFile } from 'react-icons/vsc';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useNavigate } from 'react-router-dom';
// import { FaFileExcel, FaUser } from 'react-icons/fa';
// import { MdLocationPin, MdPhone, MdPerson, MdLink, MdCurrencyRupee, MdAssignmentInd, MdCalendarToday } from 'react-icons/md';
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../context/AuthContext';

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// function getPriorityColor(priority) {
//     switch ((priority || '').toLowerCase()) {
//         case 'high': return '#E74C3C';
//         case 'mid': return '#F39C12';
//         case 'low': return '#2ECC71';
//         default: return '#888';
//     }
// }

// function formatDate(iso) {
//     if (!iso) return 'N/A';
//     const d = new Date(iso);
//     return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
// }

// export default function InquiryDetailsV4({ loggedInUser, companyData, connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const API = connectionString;
//     const path = `${API}/api/inquiries`;
//     const navigate = useNavigate();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     const [rows, setRows] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [selectionModel, setSelectionModel] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     const [filters, setFilters] = useState({ clientname: '', mobileNo: '' });
//     const [searchQuery, setSearchQuery] = useState('');
//     const [selectAll, setSelectAll] = useState(false);

//     useEffect(() => {
//         fetchData();
//     }, [paginationModel]);

//     const fetchData = async () => {
//         setLoading(true);
//         try {
//             const offset = paginationModel.page * paginationModel.pageSize;
//             const res = await axios.get(path, {
//                 params: {
//                     ...filters,
//                     offset,
//                     limit: paginationModel.pageSize,
//                     userId,
//                     companyId,
//                     role
//                 },
//                 headers: { 'Cache-Control': 'no-store' }
//             });
//             console.log("res", res.data);

//             const countRes = await axios.get(`${API}/api/inq/count`, {
//                 params: { companyId, userId, role }
//             });

//             setRows(res.data.records || []);
//             setTotalCount(res.data.records.length || 0);
//             setSelectionModel([]);
//             setSelectAll(false);
//         } catch (err) {
//             console.error('Error fetching inquiries:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch inquiries.', severity: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDelete = async () => {
//         if (selectionModel.length === 0) return;

//         try {
//             const res = await axios.post(`${path}/delete`, { userId, objAryId: selectionModel });

//             if (res.status === 204) {
//                 const inquiryNumbers = res.data?.inquiries || selectionModel;
//                 setSnackbar({
//                     open: true,
//                     message: `These inquiries have multiple follow-ups and were not deleted: ${inquiryNumbers.join(', ')}`,
//                     severity: 'warning'
//                 });
//             } else if (res.status === 200) {
//                 setSnackbar({ open: true, message: 'Deleted successfully.', severity: 'success' });
//                 fetchData();
//                 setSelectionModel([]);
//             }
//         } catch (err) {
//             let message = 'Delete failed due to an unexpected error.';
//             if (err.response) {
//                 if (err.response.status === 400) {
//                     message = err.response.data.error || err.response.data.message || 'Delete failed.';
//                 } else {
//                     message = `Delete failed with status ${err.response.status}`;
//                 }
//             }
//             setSnackbar({ open: true, message, severity: 'error' });
//         }
//     };

//     const funExportData = async () => {
//         try {
//             const res = await axios({
//                 url: `${path}/export`,
//                 method: 'GET',
//                 responseType: 'blob',
//                 params: { userId, companyId, role },
//             });

//             const url = window.URL.createObjectURL(new Blob([res.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'InquiryExport.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (err) {
//             setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//         }
//     };

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             setSelectAll(false);
//         } else {
//             const allIds = filteredRows.map(row => row.InqId);
//             setSelectionModel(allIds);
//             setSelectAll(true);
//         }
//     };

//     const filteredRows = useMemo(() => {
//         const lowerQuery = searchQuery.toLowerCase();
//         return rows.filter(row =>
//             (row.FirmName || '').toLowerCase().includes(lowerQuery) ||
//             (row.MobileNo || '').includes(lowerQuery) ||
//             (row.InqNo || '').toString().includes(lowerQuery)
//         );
//     }, [searchQuery, rows]);

//     const columns = [
//         {
//             field: 'inquiryNumber', headerName: 'Inquiry No', flex: 0.5,
//             renderCell: (params) => {
//                 const row = params.row;
//                 const inquiryDate = row.InqDate ? new Date(row.InqDate).toLocaleDateString('en-GB') : '-';
//                 return (
//                     <Box>
//                         <Typography variant="subtitle2">{row.InqNo || '-'}</Typography>
//                         <Typography variant="body2" color="text.secondary">{inquiryDate}</Typography>
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: 'FirmName', headerName: 'Client Info', flex: 2.4, sortable: false,
//             renderCell: (params) => {
//                 const row = params.row;
//                 return (
//                     <Box onClick={() => navigate('/main/v2/inquiry', { state: { mode: 'edit', inquiryData: { inquiry: row } } })}
//                         sx={{ cursor: 'pointer', whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                         <Typography variant="subtitle2" sx={{ color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}>
//                             {row.FirmName}
//                         </Typography>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <FaUser color="#FF9800" />
//                             <Typography variant="body2">{row.clientContact || '-'}</Typography>
//                         </Stack>
//                         <Typography variant="body2" color="text.secondary">📲 {row.MobileNo || '-'}</Typography>
//                         {row.EmailId && <Typography variant="body2" color="text.secondary">📧 {row.EmailId}</Typography>}
//                         {row.City && (
//                             <Typography variant="body2" color="text.secondary" display="flex" alignItems="center" gap={0.6}>
//                                 <MdLocationPin style={{ color: '#1877F2' }} /> {row.City}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             },
//         },
//         {
//             field: 'offerPrice', headerName: 'Prices', flex: 0.7, align: 'right', headerAlign: 'center',
//             renderCell: (params) => {
//                 const offer = params.row.OfferPrice || "0.00";
//                 const closing = params.row.ClosingPrice || "0.00";
//                 return (
//                     <Box>
//                         <Typography variant="body2" sx={{ fontWeight: 600 }}>Offer: ₹{offer}</Typography>
//                         <Typography variant="body2" color="text.secondary">Closing: ₹{closing}</Typography>
//                     </Box>
//                 );
//             }
//         },
//         {
//             field: 'LaststatusName', headerName: 'Status', flex: 0.5, align: 'right', headerAlign: 'right',
//             renderCell: (params) => {
//                 const status = params.value?.toLowerCase();
//                 let chipStyles = {};
//                 if (status === 'success') chipStyles = { backgroundColor: '#4caf50', color: '#fff' };
//                 else if (status === 'failed') chipStyles = { backgroundColor: '#d32f2f', color: '#fff' };
//                 else chipStyles = { backgroundColor: '#FF4C00', color: '#fff' };

//                 return (
//                     <Chip label={params.value || '—'} size="small" sx={{ fontWeight: 600, ...chipStyles }} />
//                 );
//             }
//         },
//         {
//             field: 'EmployeeName',
//             headerName: 'Lead',
//             flex: 0.6,
//             align: 'right',
//             headerAlign: 'right',
//             sortable: false,
//             renderCell: (params) => {
//                 const row = params.row;

//                 return (
//                     <Box sx={{ textAlign: 'left' }}>
//                         <Typography variant="body2">
//                             From: {row.LeadFrom || '-'}
//                         </Typography>
//                         <Typography variant="body2">
//                             To: {row.EmployeeName || '-'}
//                         </Typography>
//                     </Box>
//                 );
//             },
//         },

//         { field: 'LastleadSourceName', headerName: 'Source', align: 'right', headerAlign: 'right', flex: 0.4 },
//         { field: 'Lastpriority', headerName: 'Priority', align: 'right', headerAlign: 'right', flex: 0.2 },
//     ];

//     if (role !== "User") {
//         columns.push({
//             flex: 0.3,
//             sortable: false,
//             filterable: false,
//             disableColumnMenu: true,
//             align: 'right',
//             headerAlign: 'right',
//             renderCell: (params) => {
//                 const isSelected = selectionModel.includes(params.row.InqId);
//                 return (
//                     <Tooltip title="Delete">
//                         <span>
//                             <IconButton color="error" onClick={handleDelete} disabled={!isSelected}>
//                                 <DeleteIcon fontSize="small" />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             }
//         });
//     }

//     const renderCards = () => {
//         if (loading) return <Typography sx={{ p: 4, textAlign: 'center' }}>Loading...</Typography>;
//         if (filteredRows.length === 0) return <Typography sx={{ p: 4, textAlign: 'center' }}>No inquiries found.</Typography>;

//         return filteredRows.map((row) => {
//             const isSelected = selectionModel.includes(row.InqId);
//             const avatarColor = stringToColor(row.FirmName || 'Inquiry');
//             const initials = getInitials(row.FirmName);
//             const priorityColor = getPriorityColor(row.Lastpriority);

//             const toggleSelection = (e) => {
//                 e.stopPropagation();

//                 setSelectionModel((prev) => {
//                     const newSelection = prev.includes(row.InqId)
//                         ? prev.filter((id) => id !== row.InqId)
//                         : [...prev, row.InqId];

//                     // Update selectAll based on new selection
//                     if (newSelection.length === filteredRows.length) {
//                         setSelectAll(true);
//                     } else if (newSelection.length < filteredRows.length) {
//                         setSelectAll(false);
//                     }

//                     return newSelection;
//                 });
//             };

//             return (
//                 <Card key={row.InqId} onClick={() => navigate('/main/v2/inquiry', { state: { mode: 'edit', inquiryData: { inquiry: row } } })} sx={{ mb: 2, borderLeft: `6px solid ${priorityColor}`, borderRadius: 2, boxShadow: 2, '&:hover': { boxShadow: 4 }, cursor: 'pointer' }} >
//                     <CardContent sx={{ p: 2 }}>
//                         {/* Header: Avatar + Name + City + Status */}
//                         <Grid container alignItems="center" justifyContent="space-between">
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                                     {role !== 'User' && (
//                                         <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" />
//                                     )}
//                                     <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36 }}>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{initials}</Typography>
//                                     </Avatar>
//                                     <Box>
//                                         <Typography variant="subtitle1" sx={{ fontWeight: 600 }}> {row.FirmName || '—'} </Typography>
//                                         <Typography variant="body2" color="text.secondary"> {row.City || '—'} </Typography>
//                                     </Box>
//                                 </Box>
//                             </Grid>

//                             <Grid item>
//                                 <Box sx={{ bgcolor: priorityColor, px: 1.5, py: 0.5, borderRadius: 3 }}>
//                                     <Typography variant="caption" sx={{ color: 'white', fontWeight: 600 }}> {row.LaststatusName || '—'} | {(row.Lastpriority || '')[0] || '?'} </Typography>
//                                 </Box>
//                             </Grid>
//                         </Grid>

//                         {/* Contact + Source */}
//                         <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdPerson fontSize={18} color="gray" />
//                                     <Typography variant="body2" color="text.secondary"> {row.clientContact || 'N/A'} </Typography>
//                                 </Box>
//                             </Grid>
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdLink fontSize={18} color="gray" />
//                                     <Typography variant="body2" color="text.secondary"> {row.LastleadSourceName || 'Unknown'} </Typography>
//                                 </Box>
//                             </Grid>
//                         </Grid>

//                         {/* Phone + Closing Price */}
//                         <Grid container justifyContent="space-between" sx={{ mt: 1.5, mb: 2 }}>
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdPhone fontSize={18} color={theme.palette.primary.main} />
//                                     <Typography variant="body2" sx={{ color: theme.palette.primary.main, fontWeight: 500 }}> {row.MobileNo || 'N/A'} </Typography>
//                                 </Box>
//                             </Grid>
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdCurrencyRupee fontSize={18} color="gray" />
//                                     <Typography variant="body2" color="text.secondary"> {row.ClosingPrice || '0.00'} </Typography>
//                                 </Box>
//                             </Grid>
//                         </Grid>

//                         <Divider sx={{ my: 1.5 }} />

//                         {/* Footer: Assigned + Last Follow-up */}
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdAssignmentInd fontSize={18} color="gray" />
//                                     <Typography variant="body2" color="text.secondary" sx={{ textTransform: 'uppercase' }}> {row.EmployeeName || 'Unknown'} </Typography>
//                                 </Box>
//                             </Grid>
//                             <Grid item>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <MdCalendarToday fontSize={18} color="gray" />
//                                     <Typography variant="body2" color="text.secondary"> {formatDate(row.LastFollowUpDate)} </Typography>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Box sx={{ pt: 1, px: { xs: 2, sm: 3, md: 4 }, ml: 2 }}>
//             {/* Toolbar */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
//                 <Grid item>
//                     <Box sx={{ display: 'flex', gap: 1 }}>
//                         <Tooltip title="Add Inquiry">
//                             <IconButton sx={{ color: 'orange' }} onClick={() => navigate('/main/v2/inquiry', { state: { mode: 'insert' } })}>
//                                 <VscNewFile size={22} />
//                             </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Export to Excel">
//                             <IconButton color="success" onClick={funExportData}>
//                                 <FaFileExcel size={20} />
//                             </IconButton>
//                         </Tooltip>
//                     </Box>
//                 </Grid>

//                 <Grid item xs zeroMinWidth>
//                     <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }}> Inquiry Details </Typography>
//                 </Grid>

//                 <Grid item>
//                     <Box sx={{ width: { xs: 48, sm: 96 } }} />
//                 </Grid>
//             </Grid>

//             {/* Content */}
//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//                 <Box sx={{ p: { xs: 1, md: 2 } }}>
//                     {isSmallScreen && (
//                         <Box sx={{ mb: 2 }}>
//                             <TextField fullWidth size="small" placeholder="Search inquiries..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
//                                 InputProps={{
//                                     startAdornment: (
//                                         <InputAdornment position="start">
//                                             <SearchIcon />
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                                 variant="outlined"
//                             />
//                         </Box>
//                     )}

//                     {isSmallScreen && role !== 'User' && selectionModel.length > 0 && (
//                         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 1.5, mb: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
//                                 <Typography variant="body2" sx={{ ml: 1 }}> {selectionModel.length} selected </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={handleDelete} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {isSmallScreen ? (
//                         <Box>{renderCards()}</Box>
//                     ) : (
//                         <Box sx={{ height: '80vh', width: '100%' }}>
//                             <DataGrid autoHeight={false} getRowHeight={() => 'auto'} rows={rows} columns={columns} getRowId={(r) => r.InqId} checkboxSelection={role !== "User"} selectionModel={selectionModel} onSelectionModelChange={(newSel) => setSelectionModel(newSel.map(Number))} disableSelectionOnClick loading={loading} pagination pageSize={paginationModel.pageSize} page={paginationModel.page} rowCount={totalCount} paginationMode="server" onPageChange={(page) => setPaginationModel(p => ({ ...p, page }))} onPageSizeChange={(ps) => setPaginationModel(p => ({ ...p, pageSize: ps }))} rowsPerPageOptions={[50, 100, 150]}
//                                 sx={{
//                                     '& .MuiDataGrid-columnHeaders': {
//                                         backgroundColor: '#165bb5',
//                                         color: '#FFFFFF',
//                                         fontWeight: 'bold',
//                                     },
//                                     '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                     '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                                     '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': { color: '#ffffff !important' },
//                                     '& .MuiDataGrid-columnHeaderCheckbox .Mui-checked': { color: '#ffffff !important' }
//                                 }}
//                             />
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
//                 <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
//             </Snackbar>
//         </Box>
//     );
// }







import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Box, Grid, Paper, Typography, IconButton, Snackbar, Alert, Tooltip, Chip, Stack,
    TextField, InputAdornment, useTheme, useMediaQuery, Card, CardContent, Avatar,
    Checkbox, Divider, CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from "@mui/material";
import { VscNewFile } from "react-icons/vsc";
import DeleteIcon from "@mui/icons-material/Delete";
import { FaFileExcel, FaUser } from "react-icons/fa";
import {
    MdLocationPin, MdPhone, MdPerson, MdLink, MdCurrencyRupee,
    MdAssignmentInd, MdCalendarToday
} from "react-icons/md";
import SearchIcon from "@mui/icons-material/Search";
import { useAuth } from "../context/AuthContext";
import CommonServerDataGrid from "../components/datagridComponent";
import { formatRows } from "../utils/formatRows";
import NoDataComponent from "../components/NoDataComponent";
import CenterLoader from "../components/CenterLoader";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";


/**
 * Utility: Convert string to color
 */
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ["#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6", "#1abc9c", "#3f51b5", "#e91e63", "#795548", "#00bcd4"];
    return colors[Math.abs(hash) % colors.length];
}

/**
 * Utility: Get initials from name
 */
function getInitials(name) {
    if (!name) return "C";
    return name.trim().charAt(0).toUpperCase();
}

/**
 * Utility: Get priority color
 */
function getPriorityColor(priority) {
    switch ((priority || "").toLowerCase()) {
        case "high": return "#E74C3C";
        case "mid": return "#F39C12";
        case "low": return "#2ECC71";
        default: return "#888";
    }
}

/**
 * Utility: Format date
 */
function formatDate(iso) {
    if (!iso) return "N/A";
    const d = new Date(iso);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getFullYear()}`;
}

/**
 * InquiryDetailsV4 Component
 * 
 * Displays inquiries in two views:
 * - Desktop: CommonServerDataGrid with pagination, filtering, sorting
 * - Mobile: Card view with search and pagination
 * 
 * Features:
 * - Server-side pagination, filtering, sorting
 * - Search functionality for mobile view
 * - Bulk deletion
 * - Excel export
 * - Responsive design
 */
export default function InquiryDetailsV4({ connectionString }) {
    const { user, selectedCompany } = useAuth();
    const API = connectionString;
    const path = `${API}/api/inquiries`;
    const navigate = useNavigate();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    // ============ STATE MANAGEMENT ============

    // Shared state for both views
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [selectAll, setSelectAll] = useState(false);

    // Desktop state (DataGrid)
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // Mobile state (Search + Pagination)
    const [mobileSearchQuery, setMobileSearchQuery] = useState("");
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState("");
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });
    const [isFiltered, setIsFiltered] = useState(false);

    const pendingDeleteIdsRef = useRef([]);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

    console.log("=== COMPONENT RENDER ===");
    console.log("isSmallScreen:", isSmallScreen);
    console.log("mobileSearchQuery:", mobileSearchQuery);
    console.log("rows count:", rows.length);
    console.log("totalCount:", totalCount);
    console.log(rows)
    // ============ PARAMETER BUILDERS ============

    /**
     * Build parameters for mobile search request
     */
    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * 20;
        const params = { mode: "search", userId, companyId, role, offset, limit: 20 };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        console.log("📦 buildMobileParams:", params);
        return params;
    };

    /**
     * Build parameters for desktop request with filters and sort
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = { mode: "search", userId, companyId, role, offset, limit: pageSize };

        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {

                    // ✅ Client Name (already works)
                    case "FirmName": params.search = item.value;
                        break;

                    // ✅ Inquiry Number (FIXED — KEEP FIELD NAME)
                    case "inquiryNumber": params.search = item.value;
                        break;

                    // ✅ Mobile Number
                    case "MobileNo": params.search = item.value;
                        break;

                    // ✅ Status
                    case "LaststatusName": params.search = item.value;
                        break;

                    // ✅ Priority
                    case "Lastpriority": params.search = item.value;
                        break;

                    case "LeadFrom": params.search = item.value;
                        break;

                    case "EmployeeName": params.search = item.value;
                        break;

                    default: break;
                }
            }
        });


        // Add sorting
        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log("🖥️ buildDesktopParams:", params);
        return params;
    };

    // ============ FETCH FUNCTIONS ============

    /**
     * Fetch data for desktop view (with filters and sort)
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) return;

        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            const dataRes = await axios.get(path, { params });
            const fetchedRows = Array.isArray(dataRes.data?.records) ? dataRes.data.records : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);

            // Fetch total count
            const countParams = { userId, companyId, role };

            // Add same filters as search
            filterModel.items.forEach(item => {
                if (item.value) {
                    switch (item.field) {
                        case "FirmName": countParams.clientname = item.value;
                            break;
                        case "InqNo": countParams.inquiryNumber = item.value;
                            break;
                        case "MobileNo": countParams.mobileNo = item.value;
                            break;
                        case "LaststatusName": countParams.status = item.value;
                            break;
                        case "Lastpriority": countParams.priority = item.value;
                            break;
                        default: break;
                    }
                }
            });

            const countRes = await axios.get(`${API}/api/inq/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
        } catch (err) {
            console.error("🖥️ Fetch error:", err);
            setSnackbar({ open: true, message: "Failed to fetch inquiries.", severity: "error" });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, path, userId, companyId, role, paginationModel, filterModel, sortModel, isSmallScreen]);

    /**
     * Fetch data for mobile view (with search only)
     */
    const fetchDataMobile = useCallback(async () => {
        if (!isSmallScreen) return;

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            const dataRes = await axios.get(path, { params });
            const fetchedRows = Array.isArray(dataRes.data?.records) ? dataRes.data.records : [];
            setRows(formatRows(fetchedRows));
            setSelectionModel([]);

            const countParams = { userId, companyId, role };
            if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
                countParams.search = debouncedMobileSearch;
            }

            const countRes = await axios.get(`${API}/api/inq/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
        } catch (err) {
            console.error("📱 Fetch error:", err);
            console.error("📱 Error response:", err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: "error" });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, path, userId, companyId, role, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

    // ============ EFFECTS ============

    /**
     * Trigger desktop fetch when pagination, filters, or sort changes
     */
    useEffect(() => {
        if (!isSmallScreen) fetchDataDesktop();
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    useEffect(() => {
        if (isSmallScreen) fetchDataMobile();
    }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 400);
        return () => clearTimeout(timer);
    }, [mobileSearchQuery]);

    /**
     * Trigger fetch when debounced search changes
     */
    useEffect(() => {
        console.log("📱 [EFFECT] Debounced search changed:", debouncedMobileSearch);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

    // ============ DELETE HANDLER ============

    const handleDelete = () => {
        if (!selectionModel || selectionModel.length === 0) return;

        // 🔒 VERY IMPORTANT: freeze IDs immediately
        pendingDeleteIdsRef.current = [...selectionModel];

        setOpenDeleteDialog(true);
    };


    console.log("selectionModelLLL outside", selectionModel)
    const confirmDelete = async () => {
        const ids = pendingDeleteIdsRef.current;

        if (!ids || ids.length === 0) {
            setSnackbar({
                open: true,
                message: "No inquiry id provided.",
                severity: "error",
            });
            return;
        }
        setOpenDeleteDialog(false);
        try {
            const res = await axios.post(`${path}/delete`, { userId, objAryId: ids });
            const { deletedIds = [], blockedIds = [] } = res.data || {};
            if (deletedIds.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Deleted Successfully.",
                    severity: "success"
                });
            }

            if (isSmallScreen) {
                fetchDataMobile();
            } else {
                fetchDataDesktop();
            }
            setSelectionModel([]);

        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            // 🔴 Case: 400 + referenced IDs (business rule failure)
            if (status === 400 && data?.blockedIds?.length > 0) {
                setSnackbar({
                    open: true,
                    message: "Cannot delete the selected item(s) because they are referenced in other records.",
                    severity: "warning"
                });

            } else if (status === 400 && data?.error) {
                // 🔴 400 but no referencedIds array (generic validation)
                setSnackbar({
                    open: true,
                    message: data.error,
                    severity: "warning"
                });
            } else {
                // 🔴 unexpected / server error
                setSnackbar({
                    open: true,
                    message: "Delete failed due to an unexpected error.",
                    severity: "error"
                });
            }
        }
        finally {
            pendingDeleteIdsRef.current = [];
        }
    };

    // ============ EXPORT HANDLER ============

    const funExportData = async () => {
        try {
            const res = await axios({
                url: `${path}/export`,
                method: "GET",
                responseType: "blob",
                params: { userId, companyId, role }
            });

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "InquiryExport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            setSnackbar({ open: true, message: "Export failed.", severity: "error" });
        }
    };

    // ============ SELECT ALL TOGGLE ============

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            setSelectAll(false);
        } else {
            const allIds = rows.map(row => row.InqId);
            setSelectionModel(allIds);
            setSelectAll(true);
        }
    };

    // ============ COLUMNS DEFINITION ============

    const columns = [
        {
            field: "inquiryNumber",
            headerName: "Inquiry No",
            flex: 0.5,
            minWidth: 120,
            filterable: true,
            renderCell: (params) => {
                const row = params.row;
                const inquiryDate = row.InqDate ? new Date(row.InqDate).toLocaleDateString("en-GB") : "-";
                return (
                    <Box>
                        <Typography variant="subtitle2">{row.InqNo || "-"}</Typography>
                        <Typography variant="body2" color="text.secondary">{inquiryDate}</Typography>
                    </Box>
                );
            }
        },
        {
            field: "FirmName",
            headerName: "Client Info",
            flex: 2,
            width: 190,
            sortable: false,
            filterable: true,
            renderCell: (params) => {
                const row = params.row;
                return (
                    <Box onClick={() => navigate("/main/v2/inquiry", { state: { mode: "edit", inquiryData: { inquiry: row } } })} sx={{ cursor: "pointer", whiteSpace: "normal", wordBreak: "break-word", my: 1 }} >
                        <Typography variant="subtitle2" sx={{ color: "#1877F2", textDecoration: "underline", fontSize: "0.85rem" }}>
                            {row.FirmName}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <FaUser color="#FF9800" />
                            <Typography variant="body2">{row.clientContact || "-"}</Typography>
                        </Stack>
                        <Typography variant="body2" color="text.secondary">📲 {row.MobileNo || "-"}</Typography>
                        {row.City && (
                            <Tooltip
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            fontSize: "15px",
                                            lineHeight: "22px",
                                        }
                                    }
                                }}
                                title={
                                    `${row.Address || ""} ${row.Area || ""}, ${row.City || ""}, ${row.state || ""}, ${row.Country || ""}-${row.Pincode || ""}`
                                }
                                placement="right"
                                arrow
                            >
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    display="flex"
                                    alignItems="center"
                                    gap={0.6}
                                    sx={{ cursor: "help" }}
                                >
                                    <MdLocationPin style={{ color: "#1877F2" }} />
                                    {row.Area}{row.City ? `, ${row.City}` : ""}
                                </Typography>
                            </Tooltip>
                        )}

                    </Box>
                );
            }
        },
        {
            field: "ClosingPrice",
            headerName: "Prices",
            flex: 0.7,
            minWidth: 120,
            align: "right",
            headerAlign: "center",
            renderCell: (params) => {
                const offer = params.row.OfferPrice || "0.00";
                const closing = params.row.ClosingPrice || "0.00";
                return (
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>Offer: ₹{offer}</Typography>
                        <Typography variant="body2" color="text.secondary">Closing: ₹{closing}</Typography>
                    </Box>
                );
            }
        },
        {
            field: "LaststatusName",
            headerName: "Status",
            flex: 0.5,
            minWidth: 100,
            align: "right",
            headerAlign: "right",
            renderCell: (params) => {
                const status = params.value?.toLowerCase();
                const statusColor = params.row.StatusColor;
                let chipStyles = {};

                if (statusColor) {
                    // Use the color from database
                    chipStyles = { backgroundColor: statusColor, color: "#fff" };
                } else {
                    // Fallback to default colors if no color in database
                    const status = params.value?.toLowerCase();
                    if (status === "success") chipStyles = { backgroundColor: "#4caf50", color: "#fff" };
                    else if (status === "failed") chipStyles = { backgroundColor: "#d32f2f", color: "#fff" };
                    else chipStyles = { backgroundColor: "#FF4C00", color: "#fff" };
                }

                return (
                    <Chip label={params.value || "—"} size="small" sx={{ fontWeight: 600, ...chipStyles }} />
                );
            }
        },
        // {
        //     field: "EmployeeName",
        //     headerName: "Lead",
        //     flex: 0.6,
        //     width: 140,
        //     align: "right",
        //     headerAlign: "right",
        //     filterable: true,
        //     renderCell: (params) => {
        //         const row = params.row;
        //         return (
        //             <Box sx={{textAlign:'left'}}>
        //                 <Typography variant="body2">From: {row.LeadFrom || "-"}</Typography>
        //                 <Typography variant="body2">To: {row.EmployeeName || "-"}</Typography>
        //             </Box>
        //         );
        //     }
        // },
        {
            field: "LeadFrom",
            headerName: "Lead From",
            headerAlign: "center",
            flex: 0.4,
            width: 80,
            renderCell: ({ row }) => (
                <Box sx={{ width: "100%", textAlign: "center" }}>
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                        }}
                    >
                        {row.LeadFrom || "-"}
                    </Typography>
                </Box>
            )
        },

        {
            field: "EmployeeName",
            headerName: "Lead To",
            headerAlign: "center",
            flex: 0.4,
            width: 80,
            renderCell: ({ row }) => (
                <Box sx={{ width: "100%", textAlign: "center" }}>
                    <Typography
                        variant="body2"
                        sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                        }}
                    >
                        {row.EmployeeName || "-"}
                    </Typography>
                </Box>
            )
        },
        { field: "LastleadSourceName", headerName: "Source", flex: 0.5, width: 80, align: "right", headerAlign: "right", filterable: true, },
        { field: "Lastpriority", headerName: "Priority", flex: 0.3, minWidth: 80, align: "right", headerAlign: "right", filterable: false, }
    ];

    // Add delete button column if not User
    if (role !== "User") {
        columns.push({
            flex: 0.2,
            width: 40,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            align: "right",
            headerAlign: "right",
            renderCell: (params) => {
                const isSelected = selectionModel.includes(params.row.InqId);
                return (
                    <Tooltip title="Delete">
                        <span>
                            <IconButton color="error"  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete();
                                }} disabled={!isSelected} size="small" >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            }
        });
    }

    // ============ CARD RENDERING (MOBILE) ============

    const renderCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography sx={{ color: "text.secondary", mb: 2 }}>
                        {mobileSearchQuery ? <CustomNoDataOverlay/> : <NoDataComponent />}
                    </Typography>
                    <Typography sx={{ color: "text.secondary", fontSize: "0.85rem" }}>
                        Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {rows.map((row) => {
                    const isSelected = selectionModel.includes(row.InqId);
                    const avatarColor = stringToColor(row.FirmName || "Inquiry");
                    const initials = getInitials(row.FirmName);
                    const priorityColor = getPriorityColor(row.Lastpriority);

                    const toggleSelection = (e) => {
                        e.stopPropagation();
                        setSelectionModel((prev) => {
                            const newSelection = prev.includes(row.InqId) ? prev.filter((id) => id !== row.InqId) : [...prev, row.InqId];

                            if (newSelection.length === rows.length) {
                                setSelectAll(true);
                            } else {
                                setSelectAll(false);
                            }

                            return newSelection;
                        });
                    };

                    return (
                        <Card key={row.InqId} onClick={() => navigate("/main/v2/inquiry", { state: { mode: "edit", inquiryData: { inquiry: row } } })}
                            sx={{ mb: 2, borderLeft: `6px solid ${priorityColor}`, borderRadius: 2, boxShadow: 2, "&:hover": { boxShadow: 4 }, cursor: "pointer" }}
                        >
                            <CardContent sx={{ p: 2 }}>
                                {/* Header: Avatar + Name + Status */}
                                <Grid container alignItems="center" justifyContent="space-between">
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                            {role !== "User" && (
                                                <Checkbox checked={isSelected} onChange={toggleSelection} onClick={(e) => e.stopPropagation()} size="small" />
                                            )}
                                            <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36 }}>
                                                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                                                    {initials}
                                                </Typography>
                                            </Avatar>
                                            <Box>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                    {row.FirmName || "—"}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {row.City || "—"}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>

                                    <Grid item>
                                        <Box sx={{ bgcolor: row.StatusColor || priorityColor, px: 1.5, py: 0.5, borderRadius: 3 }}>
                                            <Typography variant="caption" sx={{ color: "white", fontWeight: 600 }}>
                                                {row.LaststatusName || "—"} | {(row.Lastpriority || "")[0] || "?"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* Contact + Source */}
                                <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdPerson fontSize={18} color="gray" />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.clientContact || "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdLink fontSize={18} color="gray" />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.LastleadSourceName || "Unknown"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                {/* Phone + Closing Price */}
                                <Grid container justifyContent="space-between" sx={{ mt: 1.5, mb: 2 }}>
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdPhone fontSize={18} color={theme.palette.primary.main} />
                                            <Typography variant="body2" sx={{ color: theme.palette.primary.main, fontWeight: 500 }}>
                                                {row.MobileNo || "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdCurrencyRupee fontSize={18} color="gray" />
                                            <Typography variant="body2" color="text.secondary">
                                                {row.ClosingPrice || "0.00"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Divider sx={{ my: 1.5 }} />

                                {/* Footer: Assigned + Last Follow-up */}
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdAssignmentInd fontSize={18} color="gray" />
                                            <Typography variant="body2" color="text.secondary" sx={{ textTransform: "uppercase" }}>
                                                {row.EmployeeName || "Unknown"}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <MdCalendarToday fontSize={18} color="gray" />
                                            <Typography variant="body2" color="text.secondary">
                                                {formatDate(row.LastFollowUpDate)}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Mobile Pagination Controls */}
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, py: 2, mt: 2 }}>
                    <button
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))}
                        disabled={mobilePaginationModel.page === 0}
                        style={{
                            padding: "8px 12px",
                            cursor: mobilePaginationModel.page === 0 ? "not-allowed" : "pointer",
                            opacity: mobilePaginationModel.page === 0 ? 0.5 : 1,
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#f5f5f5"
                        }}
                    >
                        ← Previous
                    </button>

                    <Typography variant="body2" sx={{ minWidth: "150px", textAlign: "center" }}>
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <button
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))}
                        disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount}
                        style={{
                            padding: "8px 12px",
                            cursor: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? "not-allowed" : "pointer",
                            opacity: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 0.5 : 1,
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: "#f5f5f5"
                        }}
                    >
                        Next →
                    </button>
                </Box>
            </>
        );
    };

    // ============ RENDER ============

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>
            {/* Toolbar */}
            <Box sx={{ position: 'relative', mb: 0.7 }}>
                {/* Icons - Absolute positioned on the left */}
                <Box sx={{
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    gap: 0.3,
                    zIndex: 1
                }}>
                    <Tooltip title="Add New Inquiry">
                        <IconButton sx={{ color: "orange" }} onClick={() => navigate("/main/v2/inquiry", { state: { mode: "insert" } })} >
                            <VscNewFile size={25} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Export to Excel">
                        <IconButton onClick={funExportData} color="success">
                            <FaFileExcel size={22} />
                        </IconButton>
                    </Tooltip>
                </Box>

                {/* Title - Centered */}
                <Typography
                    variant="h5"
                    sx={{
                        textAlign: 'center',
                        fontSize: { xs: '1.25rem', sm: '1.5rem' },
                        fontWeight: 600
                    }}
                >
                    Inquiry Details
                </Typography>

            </Box>

            {/* Content */}
            <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {/* Mobile Search Field */}
                    {isSmallScreen && (
                        <Box sx={{ mb: 2 }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Search inquiries..."
                                variant="outlined"
                                value={mobileSearchQuery}
                                onChange={(e) => setMobileSearchQuery(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                            />
                        </Box>
                    )}

                    {/* Debug Info */}
                    {/* {isSmallScreen && (
                        <Box sx={{ mb: 2, p: 1, bgcolor: "#f0f0f0", borderRadius: 1, fontSize: "0.75rem" }}>
                            <Typography sx={{ fontSize: "0.75rem", color: "#666" }}>
                                Debug: Search="{debouncedMobileSearch}" | Page={mobilePaginationModel.page} | Rows={rows.length} | Total={totalCount} | Loading={loading ? "Yes" : "No"}
                            </Typography>
                        </Box>
                    )} */}

                    {/* Bulk Action Bar - Mobile Only */}
                    {isSmallScreen && role !== "User" && selectionModel.length > 0 && (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 1.5, mb: 2, bgcolor: "background.paper", borderRadius: 2, boxShadow: 1 }} >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.length} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete();
                                }} color="error">
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile View - Cards */}
                    {isSmallScreen ? (
                        <Box> {renderCards()}</Box>
                    ) : (
                        /* Desktop View - CommonServerDataGrid */

                        <Box sx={{ height: '81.5vh', width: '100%' }}>

                            {/* No Data (only when NOT filtered) */}
                            {!loading && rows?.length === 0 && !isFiltered && (
                                <NoDataComponent />
                            )}

                            <CommonServerDataGrid
                                data={rows}
                                columns={columns}
                                getRowId={(row) => row.InqId}
                                role={role}
                                pageSizeOptions={[25, 50, 100]}
                                selectionModel={selectionModel}
                                onSelectionModelChange={setSelectionModel}
                                onPageChange={({ page, pageSize }) => {
                                    setPaginationModel({ page, pageSize });
                                }}
                                onFilterChange={setFilterModel}
                                onSortChange={setSortModel}
                                rowCount={totalCount}
                                onFilterStatusChange={setIsFiltered}
                            />
                        </Box>
                    )}
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Dialog
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Confirm Deletion</DialogTitle>

                <DialogContent>
                    <Typography variant="body2">
                        Are you sure you want to delete{" "}
                        <strong>{pendingDeleteIdsRef.current.length}</strong>{" "}
                        inquiries?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDeleteDialog(false)}>
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={confirmDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}